<template>
  <v-card
    class="voucher-card my-3"
    height="300"
    width="1200"
    dark
    :style="cssStyle"
    @click="$emit('click')"
  >    
    <!-- <h2>
      <code>{{ `${item.name} ${item.amount}` }}</code>
    </h2>  -->
  </v-card>
</template>
<script>
export default {
  props:{
    item:{
      type:Object,
      default:()=>{}
    }
  },
  computed : {    
    cssStyle () {

      if (this.item && this.item.image) {
        return {backgroundImage: `url(${this.item.image})`}
      }

      return {}
    },
  }, 
}
</script>
<style scoped>
.voucher-card {
  background-image: url('~@/assets/voucher/voucher-backgrond.png');
  background-position: center;
  background-size: cover; 
  display: flex;
  justify-content: center;
  align-items: center;
}
.voucher-card h2{
  text-align: center;
}
code {
  background-color: rgba(0, 0, 0, 0.4) !important;
  color: white !important;
}
</style>